import axios from '../axios'
import {
    LEAGUE_LIST_REQUEST, LEAGUE_LIST_SUCCESS, LEAGUE_LIST_FAIL,
    LEAGUE_DETAILS_REQUEST, LEAGUE_DETAILS_SUCCESS, LEAGUE_DETAILS_FAIL,
    LEAGUE_ACTIVE_REQUEST, LEAGUE_ACTIVE_SUCCESS, LEAGUE_ACTIVE_FAIL,
    LEAGUE_CREATE_REQUEST, LEAGUE_CREATE_SUCCESS, LEAGUE_CREATE_FAIL,
    LEAGUE_UPDATE_REQUEST, LEAGUE_UPDATE_SUCCESS, LEAGUE_UPDATE_FAIL,
    LEAGUE_DELETE_REQUEST, LEAGUE_DELETE_SUCCESS, LEAGUE_DELETE_FAIL,
    LEAGUE_REGISTER_PLAYER_REQUEST, LEAGUE_REGISTER_PLAYER_SUCCESS, LEAGUE_REGISTER_PLAYER_FAIL,
    LEAGUE_REMOVE_PLAYER_REQUEST, LEAGUE_REMOVE_PLAYER_SUCCESS, LEAGUE_REMOVE_PLAYER_FAIL,
    LEAGUE_GENERATE_SCHEDULE_REQUEST, LEAGUE_GENERATE_SCHEDULE_SUCCESS, LEAGUE_GENERATE_SCHEDULE_FAIL,
    LEAGUE_MATCHUP_UPDATE_REQUEST, LEAGUE_MATCHUP_UPDATE_SUCCESS, LEAGUE_MATCHUP_UPDATE_FAIL,
    LEAGUE_MATCHUP_LOCK_REQUEST, LEAGUE_MATCHUP_LOCK_SUCCESS, LEAGUE_MATCHUP_LOCK_FAIL,
    LEAGUE_SCORES_REQUEST, LEAGUE_SCORES_SUCCESS, LEAGUE_SCORES_FAIL,
    LEAGUE_SAVE_SCORE_REQUEST, LEAGUE_SAVE_SCORE_SUCCESS, LEAGUE_SAVE_SCORE_FAIL,
} from '../constants/leagueConstants'

const auth = (userInfo) => ({ headers: { Authorization: `Bearer ${userInfo.token}` } })
const authJson = (userInfo) => ({ headers: { Authorization: `Bearer ${userInfo.token}`, 'Content-Type': 'application/json' } })

export const listLeagues = () => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/league/', auth(userInfo))
        dispatch({ type: LEAGUE_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const getLeagueDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_DETAILS_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/league/${id}/`, auth(userInfo))
        dispatch({ type: LEAGUE_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_DETAILS_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const getActiveLeague = () => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_ACTIVE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/league/active/', auth(userInfo))
        dispatch({ type: LEAGUE_ACTIVE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_ACTIVE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const createLeague = (leagueData) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post('/api/league/create/', leagueData, authJson(userInfo))
        dispatch({ type: LEAGUE_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateLeague = (id, leagueData) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/league/${id}/update/`, leagueData, authJson(userInfo))
        dispatch({ type: LEAGUE_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const deleteLeague = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/league/${id}/delete/`, auth(userInfo))
        dispatch({ type: LEAGUE_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: LEAGUE_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const registerPlayer = (leagueId, userId) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_REGISTER_PLAYER_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(`/api/league/${leagueId}/register/`, { user_id: userId }, authJson(userInfo))
        dispatch({ type: LEAGUE_REGISTER_PLAYER_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_REGISTER_PLAYER_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const removePlayer = (leagueId, userId) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_REMOVE_PLAYER_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/league/${leagueId}/remove/${userId}/`, auth(userInfo))
        dispatch({ type: LEAGUE_REMOVE_PLAYER_SUCCESS, payload: userId })
    } catch (error) {
        dispatch({ type: LEAGUE_REMOVE_PLAYER_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const joinLeague = (leagueId) => async (dispatch, getState) => {
    try {
        const { userLogin: { userInfo } } = getState()
        await axios.post(`/api/league/${leagueId}/join/`, {}, auth(userInfo))
        dispatch(getActiveLeague())
    } catch (error) {
        console.error(error.response?.data?.detail || error.message)
    }
}

export const approvePlayer = (leagueId, userId, status = 'approved') => async (dispatch, getState) => {
    try {
        const { userLogin: { userInfo } } = getState()
        await axios.put(`/api/league/${leagueId}/approve/${userId}/`, { status }, authJson(userInfo))
        dispatch(getLeagueDetails(leagueId))
    } catch (error) {
        console.error(error.response?.data?.detail || error.message)
    }
}

export const generateSchedule = (leagueId) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_GENERATE_SCHEDULE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(`/api/league/${leagueId}/generate-schedule/`, {}, auth(userInfo))
        dispatch({ type: LEAGUE_GENERATE_SCHEDULE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_GENERATE_SCHEDULE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const updateMatchup = (matchupId, matchupData) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_MATCHUP_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/league/matchup/${matchupId}/update/`, matchupData, authJson(userInfo))
        dispatch({ type: LEAGUE_MATCHUP_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_MATCHUP_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const toggleMatchupLock = (matchupId) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_MATCHUP_LOCK_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/league/matchup/${matchupId}/lock/`, {}, auth(userInfo))
        dispatch({ type: LEAGUE_MATCHUP_LOCK_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_MATCHUP_LOCK_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const setMatchupDate = (matchupId, roundDate) => async (dispatch, getState) => {
    try {
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/league/matchup/${matchupId}/set-date/`, { round_date: roundDate }, authJson(userInfo))
        dispatch({ type: LEAGUE_MATCHUP_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_MATCHUP_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const getMatchupScores = (matchupId) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_SCORES_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/league/matchup/${matchupId}/scores/`, auth(userInfo))
        dispatch({ type: LEAGUE_SCORES_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_SCORES_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const saveHoleScore = (matchupId, holeNumber, score) => async (dispatch, getState) => {
    try {
        dispatch({ type: LEAGUE_SAVE_SCORE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post(`/api/league/matchup/${matchupId}/score/`, { hole_number: holeNumber, score }, authJson(userInfo))
        dispatch({ type: LEAGUE_SAVE_SCORE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: LEAGUE_SAVE_SCORE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
